import Vue from 'vue';
import { serverTableOptions, toastrOptions } from './options';
import BootstrapVue from 'bootstrap-vue';
import Vselect from 'vue-select';
import miniToastr from 'mini-toastr';
import { ServerTable } from 'vue-tables-2';

// Notification messages initialization
const notification = {
    install(Vue, options) {
        Vue.prototype.$Notification = miniToastr.init(toastrOptions);
    }
};

const mods = [
    { modName: BootstrapVue },
    { modName: ServerTable, option: serverTableOptions },
    { modName: notification }
];

const components = [
    { name: Vselect, id: 'v-select' }
];

mods.forEach(mod => Vue.use(mod.modName, (mod.option) ? mod.option : null));
components.forEach(component => Vue.component(component.id, component.name));



// WEBPACK FOOTER //
// ./src/thirdparty/index.js